import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

// https://dataportal.zillowgroup.net/event-registry/3900
export const OPEN_FILTER_MENU_EVENT_TYPE_ID = '3900';
export const emitOpenFilterMenuEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: OPEN_FILTER_MENU_EVENT_TYPE_ID,
      event_type_version_id: '2',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'filter_menu',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
